import {
  BUNDLE_TYPE_COMBO,
  EXPERIENCE_TYPE_GM,
  BUNDLE_TYPE_PACKAGE,
  EXPERIENCE_TYPE_KITCHEN,
  EXPERIENCE_TYPE_LAUNDRY
} from './base-configuration';

export const COMBO_CONFIGURATION = {
  quickView: false,
  productListModelNumber: false,
  productListRating: false,
  productListViewSpecificationLink: true,
  allowSwap: false,
  allowRemove: false,
  productLabelScrollableLink: true,
  brandNameScrollableLink: true,
  disableAccordionInteractionsWhenUnavailable: true
};

export const PACKAGE_CONFIGURATION = {
  quickView: true,
  productListModelNumber: true,
  productListRating: true,
  productListViewSpecificationLink: false,
  allowSwap: true,
  allowRemove: true,
  productLabelScrollableLink: false,
  brandNameScrollableLink: false,
  disableAccordionInteractionsWhenUnavailable: false
};

export const KITCHEN_PACKAGE = {
  ...PACKAGE_CONFIGURATION,
  productListFuelType: true,
  directDeliveryCartMethod: true,
  showVariantDrawerInfoIcon: false,
  showApplianceType: false
};

export const LAUNDRY_PACKAGE = {
  ...PACKAGE_CONFIGURATION,
  directDeliveryCartMethod: true,
  showVariantDrawerInfoIcon: true,
  productListViewSpecificationLink: true,
  allowSwap: false,
  allowRemove: false,
  showApplianceType: true,
  productListFuelType: true,
  unavailableAlertStatus: 'warning',
  unavailableAlertHeadline: 'Some Accessories are Unavailable.',
  oosAlertHeadline: 'Some Accessories are Out of Stock.',
  unavailableAlertAdditionalText: 'Set can be purchased with or without accessories'
};

export const GM_COMBO = {
  ...COMBO_CONFIGURATION,
  showVariantDrawerInfoIcon: false,
  showApplianceType: false
};

export const GM_PACKAGE = {
  ...PACKAGE_CONFIGURATION,
  showVariantDrawerInfoIcon: false,
  productListViewSpecificationLink: true,
  allowSwap: true,
  allowRemove: true,
  productLabelScrollableLink: true,
  brandNameScrollableLink: true,
  quickView: false,
  showApplianceType: false
};

export const PRODUCTS_CONFIGURATION = {
  [BUNDLE_TYPE_COMBO]: {
    [EXPERIENCE_TYPE_GM]: GM_COMBO
  },
  [BUNDLE_TYPE_PACKAGE]: {
    [EXPERIENCE_TYPE_KITCHEN]: KITCHEN_PACKAGE,
    [EXPERIENCE_TYPE_LAUNDRY]: LAUNDRY_PACKAGE,
    [EXPERIENCE_TYPE_GM]: GM_PACKAGE
  }
};